const mode = "production";
// const mode = 'development';
const api = mode === 'production'?'https://api.docircuit.org:3001':'http://192.168.76.23:3001'

export const loginState = {
  cid: "",
  mcd: "",
  level: "",
};

export const configState = {
    cid: 'CID000000HR',
    name: '두써킷 (HR)',
    api:api
}
